import React from 'react';
import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/common/PageLayout';

const OrderDetailPage = () => {
  const { id } = useParams();
  return (
    <PageLayout contentMaxWidth="lg" showHeaderImage={false} showOrgHeader>
      <Typography variant="h5" gutterBottom>Order Details</Typography>
      <Typography variant="body1">Order ID: {id}</Typography>
    </PageLayout>
  );
};

export default OrderDetailPage;
